import axios from "axios"

//pass new generated access token here
import { node } from "../config.js"
//mport { getSession, setSession, getJwt } from "./AuthType/authService"

//apply base url for axios
const API_URL = 
process.env.REACT_APP_PRODUCTION === "prod"
  ? node.baseUrl
  : process.env.REACT_APP_PRODUCTION === "stage"
  ? node.stageUrl
  : node.devUrl

const tokenKey = "token"

axios.defaults.headers.common["crossDomain"] = true
axios.defaults.headers.common["x-esf-apply-auth-token"] = getJwt()



function axiosApi() {
  const apiClient = axios.create({
    baseURL: API_URL,
  });

  

// Add a response interceptor
apiClient.interceptors.response.use(
  // Handle successful responses
  (response) => {
    // Optionally, you can preprocess the response here
    return response;
  },
  // Handle errors
  (error) => {
    if (error.response) {
      console.log({errorResponse : error.response})
      // Server responded with a status outside the 2xx range
      const { status, data } = error.response;

      // Customize the error based on status or server response
      switch (status) {
        case 400:
          return Promise.reject(new Error(data.message || 'Bad Request'));
        case 401:
          return Promise.reject(new Error('Unauthorized. Please log in again.'));
        case 403:
          return Promise.reject(new Error('Forbidden. You do not have access.'));
        case 404:
          return Promise.reject(new Error('Resource not found.'));
        case 500:
          return Promise.reject(new Error('Internal Server Error.'));
        default:
          return Promise.reject(
            new Error(_.isString(data) ? data : data.message || `Unexpected error: ${status}`)
          );
      }
    } else if (error.request) {
      // No response was received from the server
      return Promise.reject(new Error('Network error. Please check your connection.'));
    } else {
      // Something else happened while setting up the request
      return Promise.reject(new Error(error.message || 'Unexpected error occurred.'));
    }
  }
);

return apiClient;

}

export function setJwtAuthToken(jwt) {
  axios.defaults.headers.common["x-esf-apply-auth-token"] = jwt
}

export async function get(url, config = {}) {
  return await axiosApi()
    .get(url, { ...config })
    .then(response => response.data)
}

export async function postReturnHeaders(url, data, config = {}) {
  return await axiosApi()
    .post(url, { ...data }, { ...config })
    .then(response => response)
}

export async function post(url, data, config = {}) {
  return await axiosApi()
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return await axiosApi()
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi()
    .delete(url, { ...config })
    .then(response => response.data)
}

export function getJwt() {
  return sessionStorage.getItem(tokenKey)
}
